import { isValidNum } from "../../../../utilities/typeGuard";

export function mapMakeToBilinfo(make: string) {
  switch (make) {
    case "Mercedes-Benz": return "Mercedes"
    case "Mini": return "MINI"
    default: return make;
  }
}

export function mapBodyTypeToBilinfo(bodyTypeId: number): string[] {
  switch (bodyTypeId) {
    case 1: return ["Sedan"];
    case 2: return ["Stationcar", "Station wagon"];
    case 3: return ["Cabriolet", "Convertible"];
    case 4: return ["Coupé", "Coupé"];
    case 5: return ["SUV", "SUV"];
    case 6: return ["Varebil", "Van"];
    case 7: return ["Motorcycle", "Motorcykel"];
    case 8: return ["Pickup", "Pickup"];
    case 9: return ["Hatchback", "Hatchback"];
    default: return [];
  }
}

export function mapGearboxToBilinfo(gearboxId: number): string[] {
  switch (gearboxId) {
    case 1: return ["Manual", "Manual gear", "Manuel gear", "Manuel"];
    case 2: return ["Automatic", "Automatgear"];
    default: return [];
  }
}
export function mapFuelToBilinfo(fuelId: number): string[] {
  switch (fuelId) {
    case 1: return ["Petrol", "Benzin"];
    case 2: return ["Disel", "Diesel"];
    case 3: return ["Hybrid"];
    case 4: return ["Electric", "El"];
    default: return []
  }
}

export const roundToNearest = (num: unknown, power: number = 3) => {
  if (!isValidNum(num)) return 0;
  const base = Math.pow(10, power)
  return Math.floor(num / base) * base
}
